let modal = () => {
  document.addEventListener("DOMContentLoaded", () => {
    // Functions to open and close a modal
    function openModal($el, $vid_src) {
      $el.classList.add("is-active");

      if ($el.classList.contains("js-modal-youtube")) {
        let youTubeSrc = $el.dataset.src;
        $el.querySelector("iframe").setAttribute("src", youTubeSrc);
      }
      if ($el.classList.contains("js-modal-vimeo")) {
        $el.querySelector("iframe").setAttribute("src", $vid_src);
      }
      if ($el.classList.contains("js-modal-mp4")) {
        let videoPlayer = document.querySelector('.js-modal-mp4 video');
        videoPlayer.src = $vid_src;
      }
    }

    function closeModal($el) {
      $el.classList.remove("is-active");

      if ($el.classList.contains("js-modal-youtube")) {
        $el.querySelector("iframe").removeAttribute("src");
      }
      if ($el.classList.contains("js-modal-vimeo")) {
        $el.querySelector("iframe").removeAttribute("src");
      }
      if ($el.classList.contains("js-modal-mp4")) {
        let videoPlayer = document.querySelector('.js-modal-mp4 video');
        videoPlayer.src = '';
      }
    }

    function closeAllModals() {
      (document.querySelectorAll(".modal") || []).forEach(($modal) => {
        closeModal($modal);
      });
    }

    // Add a click event on buttons to open a specific modal
    (document.querySelectorAll(".js-modal-trigger") || []).forEach(
      ($trigger) => {
        const modal = $trigger.dataset.target;
        const src = $trigger.dataset.src;
        const $target = document.getElementById(modal);

        $trigger.addEventListener("click", (e) => {
          e.preventDefault();
          openModal($target, src);
        });
      }
    );

    // Add a click event on various child elements to close the parent modal
    (
      document.querySelectorAll(
        ".modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button"
      ) || []
    ).forEach(($close) => {
      const $target = $close.closest(".modal");

      $close.addEventListener("click", () => {
        closeModal($target);
      });
    });

    // Add a keyboard event to close all modals
    document.addEventListener("keydown", (event) => {
      const e = event || window.event;

      if (e.keyCode === 27) {
        // Escape key
        closeAllModals();
      }
    });
  });
};

export { modal };
